
import React from 'react'
import { connect } from 'react-redux'
import { Layout,Avatar, Menu, Breadcrumb,Button,Row, Col, Divider,Card,Dropdown,Switch,
    message, Tooltip,InputNumber,Table,Popover,Modal,Image,Form,Select,Spin,Input} from 'antd';
import { Drawer, List,Alert,Affix } from 'antd';

import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LaptopOutlined,
  NotificationOutlined,
  SettingOutlined,
  AuditOutlined,
  IdcardOutlined,
  BarsOutlined,
  ShopOutlined,
  DollarOutlined,
  PicLeftOutlined,
  LogoutOutlined,
  EditOutlined, 
  EllipsisOutlined,
  HomeOutlined,
  SnippetsOutlined,
  KeyOutlined,
  FilePdfFilled,
  RightCircleFilled,
  DollarCircleOutlined,
  AccountBookOutlined,
  FilePptOutlined,
  PayCircleOutlined,
  BarChartOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
  BankFilled,
  AndroidOutlined,
  DeploymentUnitOutlined,
  GroupOutlined,
  AccountBookFilled,
  CalculatorFilled,
  FileFilled,
  MessageFilled,
  LoadingOutlined,
  FundViewOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { Badge, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';
import UIfx from 'uifx';

import { NavLink } from 'react-router-dom'
import { PageHeader, Descriptions } from 'antd';
import { Link,withRouter} from 'react-router-dom';
import * as actions from '../../store/actions/auth'
import axios from 'axios'
import UserAccountUpdateForm from '../components/UserAccountUpdateForm'
import WrappedPasswordResetForm from './PasswordResetForm'
import * as serverconfig from '../serverconn'
import {
  SystemHealthAlerts,
  fetchUnbalancedJournalsFyAlert,
  fetchTransactionsMissingJournalsFyAlert,
  fetchCurrentUserBranchManager,
  showUnbalancedJournalsNotification,
  showTransactionsMissingJournalsNotification,
} from '../systemHealthAlerts'
import * as serversocketconfig from '../serversocketconfig'

import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import ReconnectingWebSocket from 'reconnecting-websocket';
import tickAudio from '../../assets/sounds/that-was-quick.mp3';
import IdleTimer from 'react-idle-timer';

var CryptoJS = require("crypto-js");

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
const style = { background: '#0092ff', padding: '8px 0' };
const { Meta } = Card;
const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


const tick = new UIfx(tickAudio,  {
  volume: 1.0, // number between 0.0 ~ 1.0
  throttleMs: 100
});

const pStyle = {
  fontSize: 16,
  lineHeight: '24px',
  display: 'block',
  marginBottom: 16,
};



const DescriptionItem = ({ title, content }) => (
  <div
    className="site-description-item-profile-wrapper"
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
    }}
  >
    <p
      className="site-description-item-profile-p"
      style={{
        marginRight: 8,
        display: 'inline-block',
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

var bizuserid= ''
var sacco= ''
var token= ''


class SaccoLayout extends React.Component{

  state = {
    collapsed: false,
    theme: 'dark',
    current: '1',
    titlecolor: '#fff',
    titlevisibility:"visible",
    userprofile:{},
    companyprofile:{},
    appprofile:{},

    isToggle: null,
    visible: false,
    resetmodalvisible:false,
    updateformvisible:'none',
    userrights:{},
    date_today:moment().format(dateFormat).toString(),
    dashboardlocked:false,
    userbalancemodalvisible:false,
    userto:'',
    transferamount:0,
    datarequested:false,
    transfermode:'',
    safemanagertransfermode:'',
    numberofnotifications:0,
    notificationinfo:'',
    balanceacceptancemodalvisible:false,
    selectedtransferobject:{},
    acceptancestatus:'',

    isTimedOut: false,
    showtimeoutmodal:false

  };

  // show the profile modal
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  // update user profile
  showUpdateForm=()=>{
    this.state.updateformvisible=="none"?
    this.setState({
      updateformvisible: "block",
    })
    :
    this.setState({
      updateformvisible: "none",
    })    
  }


  /////////////////////////////////////////////
  //PASSWORD RESET MODAL METHODS BEGIN HERE

  showpasswordresetModal = () => {
    this.setState({
      resetmodalvisible: true,
    });
  };

  //Item addition success
  onresetdrawerClose = () => {
    this.setState({ resetmodalvisible: false });

  };


  //show user balance modal
  showuserbalancemodalvisible=()=>{
    this.setState({ userbalancemodalvisible: true });
  }

  hideuserbalancemodalvisible=()=>{
    this.setState({ userbalancemodalvisible: false });
  }

  //show hide balance acceptance modal
  openbalanceacceptancemodalmodal=(record)=>{
    this.setState({ acceptancestatus: ''})
    //console.log(record)
    this.setState({balanceacceptancemodalvisible: true });
    this.setState({selectedtransferobject:record})

  }

  closebalanceacceptancemodalmodal=()=>{
    this.setState({balanceacceptancemodalvisible: false });

  }



//component did mount
  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        bizuserid= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    //component mount method
    this.componentmountmethod();
    
  }

//component mount method
componentmountmethod=()=>{

  axios.get(serverconfig.backendserverurl+`/api/accounts/${bizuserid}`)
  .then(res => {
      this.setState({
        userprofile:res.data
      })
  })


  axios.get(serverconfig.backendserverurl+`/api/saccos/${sacco}`)
  .then(res => {
      this.setState({
        companyprofile:res.data
      })

      if (res.data.activated===false){
        this.setState({dashboardlocked:true})
      }
  })


  axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
  .then(res => {
      this.setState({
        userrights:res.data[0]
      })
  })

  this.loadSystemHealthAlerts();

}

loadSystemHealthAlerts = () => {
  if (!sacco) {
    return;
  }

  fetchCurrentUserBranchManager().then((isBranchManager) => {
    if (isBranchManager) {
      fetchUnbalancedJournalsFyAlert(sacco, 5)
        .then((res) => {
          showUnbalancedJournalsNotification(res.data, true);
        })
        .catch((err) => {
          console.log('Unbalanced journals alert check failed', err);
        });
    }
  });

  fetchTransactionsMissingJournalsFyAlert(sacco, 5)
    .then((res) => {
      showTransactionsMissingJournalsNotification(res.data);
    })
    .catch((err) => {
      console.log('Transactions missing journals alert check failed', err);
    });
}



  //method for changing color theme 
  changeTheme = value => {
    this.setState({
      theme: value ? 'dark' : 'light',
    });

    this.setState({
      titlecolor: value ? '#fff' : '#A9A9A9',
    });
    

  };

  //method for collupsing of the menu
  onCollapse = collapsed => {
    console.log(collapsed);
    this.setState({ collapsed });
    this.setState({titlevisibility: collapsed ? "hidden" :"visible"});
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });

    this.setState({titlevisibility:"hidden"});

  };


   render(){


    return (
      <div>

      <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={()=>{}}
            onIdle={()=>{
              this.props.logout()

/*           console.log("AM IDLE")

              const isTimedOut = this.state.isTimedOut

              if (isTimedOut) {
              } else {
                  this.setState({showtimeoutmodal: true})
                  this.idleTimer.reset();
                  this.setState({isTimedOut: true})
                }*/

            }}
            onAction={()=>{}}
            debounce={250}
            timeout={this.state.companyprofile.sessiontimeoutmilliseconds} />


        {
         this.props.isAuthenticated ?
         <Layout style={{ minHeight: '100vh' }} >
           {
             this.state.dashboardlocked===false?
             <Sider
             collapsedWidth="0"
             collapsed={this.state.collapsed}
             onCollapse={this.onCollapse} 
             theme={this.state.theme}
             breakpoint="lg"
             onBreakpoint={broken => {
               console.log(broken);
             }}
             zeroWidthTriggerStyle={{display:'none'}}
             style={{width:400}}
             >
               <br></br>
              <div className="logo" style={{ paddingLeft: 30}} mode="inline">
              <Row>
   
                <Col span={6}>
   {/*               <Avatar size={40} icon={<UserOutlined />} alt="Logo" src={this.state.companyprofile.company_logo} />
           */}               
                <Image
                 width={50}
                 height={50}
                 src={this.state.companyprofile.sacco_logo}   
                 preview={false} 
                 />
                <h6 style={{display:'flex',color:'white',margin:3}}>{this.state.companyprofile.sacco_name}</h6> 

                </Col>
   {/*             <Col span={18}><NavLink to='/'><h5 style={{color:this.state.titlecolor,paddingTop: 10,visibility:this.state.collapsed?"hidden":"visible" }}>{this.state.companyprofile.company_name}</h5></NavLink></Col>
         */}           </Row>
              <br/>
              </div>
   
              <Menu 
              theme={this.state.theme}
              onClick={this.handleClick}
              defaultSelectedKeys={['1']} 
              mode="vertical"
              style={{ backgroundColor: '@menu-bg' }} // Use the modified variable for menu background

              
              >
   
               <SubMenu
                  key="sub1"
                  title={
                    <span>
                      <HomeOutlined />
                      <span>Home</span>
                    </span>
                  }
                >
               <Menu.Item key="0" >
                 <RightCircleFilled />
                 <NavLink to='/'><span>Home</span></NavLink>
               </Menu.Item>


               <Menu.Item key="890" >
                 <RightCircleFilled />
                 <NavLink to='/quickmenu/'><span>Quick Menu</span></NavLink>
   
               </Menu.Item>

               <Menu.Item key="89000" >
                 <RightCircleFilled />
                 <NavLink to='/statistics/'><span>Statistics</span></NavLink>
               </Menu.Item>


               </SubMenu>
   
               <SubMenu
                  key="sub2"
                  title={
                    <span>
                      <UserOutlined />
                      <span>Members</span>
                    </span>
                  }
                >
                {
                  this.state.userrights.can_view_members?
                  <Menu.Item key="1" >
                  <RightCircleFilled />
                  <NavLink to='/members/'><span>Members</span></NavLink>
                  </Menu.Item>
                  :
                  null
                }

                {
                  this.state.userrights.can_view_members?
                    this.state.companyprofile.showgroupaccounts?
                    <Menu.Item key="39" >
                    <RightCircleFilled />
                    <NavLink to='/groups/'><span>Groups</span></NavLink>
                    </Menu.Item>
                    :
                    null
                  :
                  null
                }                

                {
                  this.state.userrights.can_view_members?
                  <Menu.Item key="36" >
                    <RightCircleFilled />
                    <NavLink to='/financialstatement/'><span>Financial Statement</span></NavLink>
                  </Menu.Item>
                  :
                  null
                }


                {
                this.state.userprofile.branch_manager?
                <Menu.Item key="908" >
                 <RightCircleFilled />
                <NavLink to='/fixeddeposits/'><span>Fixed Deposits</span></NavLink>
                </Menu.Item>
                  :
                  null
                }

               </SubMenu>
   
               <SubMenu
                  key="sub3"
                  title={
                    <span>
                      <AccountBookFilled />
                      <span>Loans</span>
                    </span>
                  }
                >

                {
                  this.state.userrights.can_assess_loans?
                  <Menu.Item key="3" >
                  <RightCircleFilled />
                  <NavLink to='/loanapplications/'><span>Applications</span></NavLink>
                 </Menu.Item>
                  :
                  null
                }                  

               
               {
                  this.state.userrights.can_approve_loans && this.state.companyprofile.three_step_loanprocess===false?
                  <Menu.Item key="4" >
                  <RightCircleFilled />
                  <NavLink to='/loanassessments/'><span>Assessments</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                }                

   
               {
                  this.state.userrights.can_issue_loans?
                  <Menu.Item key="5" >
                  <RightCircleFilled />
                  <NavLink to='/loanapprovals/'><span>Approvals</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                }    

   
                {
                  this.state.userrights.can_register_loans?
                  <Menu.Item key="58987" >
                  <RightCircleFilled />
                  <NavLink to='/rejectedloanapplications/'><span>Rejected Application </span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                } 


               {
                  this.state.userrights.viewissuedloans?
                  <Menu.Item key="6" >
                  <RightCircleFilled />
                  <NavLink to='/loanissues/'><span>Disbursements</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                }    

   
               </SubMenu>
   
                         
               {
                  this.state.userprofile.branch_manager?
                  <SubMenu
                  key="sub8"
                  title={
                    <span>
                      <SettingOutlined />
                      <span>Settings</span>
                    </span>
                  }
                >
              
               <Menu.Item key="22233" >
                 <NavLink to='/companyaccounts/'><span>Chart of accounts (COA) </span></NavLink>
               </Menu.Item> 

               <Menu.Item key="37" >
                 <NavLink to='/companyprofile/'><span>Company Profile</span></NavLink>
               </Menu.Item>
               <Menu.Item key="38" >
                 <NavLink to='/useraccounts/'><span>User Accounts</span></NavLink>
               </Menu.Item>

               <Menu.Item key="11" >
                 <NavLink to='/membertypes/'><span>Member Types</span></NavLink>
               </Menu.Item>

               <Menu.Item key="14" >
                 <NavLink to='/idtypes/'><span>ID Types</span></NavLink>
               </Menu.Item> 

               <Menu.Item key="2211233" >
                 <NavLink to='/ugdistricts/'><span>Ugandan districts </span></NavLink>
               </Menu.Item> 


               <Menu.Item key="13" >
                 <NavLink to='/loantypes/'><span>Loan Types</span></NavLink>
               </Menu.Item>        


               <Menu.Item key="211127000722228811233" >
                 <NavLink to='/dataonboarding/'><span>Data uploads</span></NavLink>
               </Menu.Item> 


             {/*  <Menu.Item key="45" >
                 <NavLink to='/loggedinusers/'><span>Logged In Accounts</span></NavLink>
               </Menu.Item> */}


               </SubMenu>
               
                :
                null
              } 


               <SubMenu
                  key="sub9"
                  title={
                    <span>
                      <FilePdfFilled />
                      <span>Financial Reports</span>
                    </span>
                  }
                >

                {
                  this.state.userrights.viewtill?
                  <Menu.Item key="23" >
                  <NavLink to='/tillsheet/'><span>Journal</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                } 


                {
                  this.state.userrights.viewtill?
                  <Menu.Item key="221123" >
                  <NavLink to='/ledgerreport/'><span>Ledger</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                } 


                {
                  this.state.userrights.viewtill?
                  <Menu.Item key="22123" >
                  <NavLink to='/trialbalance/'><span>Trial Balance</span></NavLink>
                  </Menu.Item>                  
                  :
                  null
                } 


                {
                  this.state.userprofile.branch_manager?
                  <Menu.Item key="26" >
                  <NavLink to='/incomestatement/'><span>Income Statement</span></NavLink>
                </Menu.Item>
                :
                null
                }


                {
                  this.state.userprofile.branch_manager?
                  <Menu.Item key="26002" >
                  <NavLink to='/cashflow_report/'><span>Cashflow / Cashbook report</span></NavLink>
                  </Menu.Item>
                :
                null
                }



              {
                this.state.userprofile.branch_manager?
                <Menu.Item key="34" >
                <NavLink to='/balancesheet/'><span>Balance Sheet</span></NavLink>
                </Menu.Item>
                :
                null
                }


                {
                  this.state.userrights.can_view_members?
                  <Menu.Item key="25" >
                  <NavLink to='/memberbalances/'><span>Member Summary Report</span></NavLink>
                  </Menu.Item>               
                  :
                  null
                } 


                {
                  this.state.userprofile.branch_manager ?
                  <Menu.Item key="340" >
                  <NavLink to='/member_autopaymentsreport/'><span>Member auto payments report</span></NavLink>
                  </Menu.Item>
                  :
                  null
                 }


                {
                  this.state.userprofile.branch_manager ?
                  <Menu.Item key="34000" >
                  <NavLink to='/periodic_performance_report/'><span>Periodic performance summary report</span></NavLink>
                  </Menu.Item>
                  :
                  null
                  }




              
               </SubMenu>


               <SubMenu
                  key="sub10"
                  title={
                    <span>
                      <FilePdfFilled />
                      <span>Loan Reports</span>
                    </span>
                  }
                >


              {
                  this.state.userrights.loandailyreport?
                  <Menu.Item key="27" >
                  <NavLink to='/dayloanreport/'><span>Day Loan Report</span></NavLink>
                  </Menu.Item>           
                  :
                  null
                } 

                {
                  this.state.userrights.outstandingloans?
                  <Menu.Item key="28" >
                  <NavLink to='/loanoutstanding/'><span>Out Standing Report</span></NavLink>
                  </Menu.Item>        
                  :
                  null
                } 


                {
                  this.state.userrights.loanrepaymentstatus?
                  <Menu.Item key="29" >
                  <NavLink to='/loanrepaymentstatus/'><span>Loan Repayment Status Report</span></NavLink>
                  </Menu.Item>       
                  :
                  null
                } 


                {
                  this.state.userrights.loandefaultsreport?
                  <Menu.Item key="30" >
                  <NavLink to='/loandefaults/'><span>Loan Defaults Report</span></NavLink>
                  </Menu.Item>      
                  :
                  null
                } 


                {
                  this.state.userrights.loanagingreport?
                  <Menu.Item key="31" >
                  <NavLink to='/loanaging/'><span>Loan Aging Report</span></NavLink>
                 </Menu.Item>   
                  :
                  null
                } 


                {
                  this.state.userrights.loandisburshmentreport?
                  <Menu.Item key="32" >
                  <NavLink to='/loandisbursement/'><span>Loan Disbursement</span></NavLink>
                 </Menu.Item>
                  :
                  null
                } 


                {
                  this.state.userrights.searchloanrepayments?
                  <Menu.Item key="33" >
                  <NavLink to='/loanrepaymentreport/'><span>Loan Repayments</span></NavLink>
                </Menu.Item>
                  :
                  null
                } 

              </SubMenu>


              <SubMenu
                  key="sub11"
                  title={
                    <span>
                      <FilePdfFilled />
                      <span>Other Reports</span>
                    </span>
                  }
                >
                {
                this.state.userprofile.branch_manager?
                <Menu.Item key="110" >
                <NavLink to='/saccosmsusagestatement/'><span>SMS Usage Report</span></NavLink>
                </Menu.Item>
                :
                null
                }


                {
                this.state.userprofile.branch_manager?
                <Menu.Item key="1110" >
                <NavLink to='/sentemailsreport/'><span>Emails sent report</span></NavLink>
                </Menu.Item>
                :
                null
                }

                {
                this.state.userprofile.branch_manager?
              <Menu.Item key="227000722228811233" >
                 <NavLink to='/systemlogs/'><span>System logs</span></NavLink>
               </Menu.Item> 
                :
                null
                } 


                  </SubMenu>

   
              </Menu>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
   { /*          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <br></br>
                 <Switch
                    checked={this.state.theme === 'dark'}
                    onChange={this.changeTheme}
                    checkedChildren="Dark"
                    unCheckedChildren="Light"
                  />
              <br></br>
                 </div> */}
   
            </Sider>
             :
             null
           }
        
         <Layout className="site-layout">
   
            <PageHeader
              style={{backgroundColor: "white"}}
              ghost={true}
              tags={React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {className: 'trigger',
              onClick: this.toggle,
            })}
              extra={[
                <Badge  onClick={()=>{this.showuserbalancemodalvisible()}}  pill color="danger">{this.state.numberofnotifications}</Badge>,
                <Avatar size={30} icon={<UserOutlined />} alt="User Pic" src={serverconfig.backendserverurl+this.state.userprofile.profile_pic} />,
                <Dropdown.Button overlay={(    <Menu >
                  <Menu.Item key="1" onClick={this.props.logout}>
                    <LogoutOutlined />
                    Log out
                  </Menu.Item>
                  <Menu.Item key="2" onClick={this.showDrawer}>
                    <UserOutlined />
                    View Profile
                  </Menu.Item>
                  <Menu.Item key="3" onClick={this.showpasswordresetModal}>
                    <KeyOutlined />
                    Change Password
                  </Menu.Item>
                  {
                    this.state.companyprofile.userbalancesfeature?
                    <Menu.Item key="4" onClick={this.showuserbalancemodalvisible}>
                    <DollarCircleOutlined />
                    User Balance
                    </Menu.Item>        
                    :
                    null
                  }
            
                </Menu>)}>
                Hi, {this.state.userprofile.username}
                </Dropdown.Button>
              ]}
              >
          </PageHeader>
        


           <Content style={{ margin: '0 16px' }}>
             <br></br>
             <SystemHealthAlerts />
             {
               this.state.notificationinfo===""?
               null
               :
               <NavLink >
                <Alert showIcon message={this.state.notificationinfo} type="info" onClick={()=>{this.showuserbalancemodalvisible()}} />
               </NavLink>


             }

             <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          
             <br></br>
            <div style={{display:'flex',flexDirection:'row'}}>
            
            {
            this.props.location.pathname==='/'?
            null:
            <Affix>

            <Tooltip title="Go to home">
            <HomeOutlined style={{display:'flex',fontSize: 30,marginRight:30}} onClick={()=>{
              this.props.history.push('/')      
              }}/>
            </Tooltip>
            </Affix>
              }


              {
                this.props.location.pathname==='/'?
                null:
                <Affix>
                <Tooltip title="Go back">
                <ArrowLeftOutlined style={{display:'flex',fontSize: 30,marginRight:5}} onClick={()=>{
                  this.props.history.goBack()      
                  }}/>
                </Tooltip>
                </Affix>
              }

            </div>
            <br></br>
          
          
             {this.props.children}
             </div>
           </Content>
           <Footer style={{ textAlign: 'center' }}>System Design © 2021 Created by PI-Tech</Footer>
         </Layout>
       </Layout>
         :
         <Layout style={{ minHeight: '100vh' }}>
         <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
           <div className="site-layout-background" style={{padding: 24, minHeight: 380,display: 'flex',  justifyContent:'center', alignItems:'center' }}>
             {this.props.children}
           </div>
         </Content>
         <Footer style={{ textAlign: 'center' }}>System Design © 2021 Created by PI-Tech</Footer>
         </Layout>
        }

        <Drawer
          title="Account Profile"
          width={520}
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
             <Avatar
              size={100}
              icon={<UserOutlined />}
              alt="client logo"
              src={serverconfig.backendserverurl+this.state.userprofile.profile_pic}
              />
          </p>
          <Row>
            <Col span={12}>
              <DescriptionItem title="User Name" content={this.state.userprofile.username} />
            </Col>
            <Col span={12}>
              <DescriptionItem title="Email" content={this.state.userprofile.email} />
            </Col>
          </Row>         
          <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
             <Button type="primary" onClick={this.showUpdateForm}>
               {
                 this.state.updateformvisible=="none"?
                 "Open Update Form"
                 :
                 "Close Update Form"
               }
               
               </Button>
          </p>
          
          <div style={{display:this.state.updateformvisible}}>
           <UserAccountUpdateForm accountID={this.state.userprofile.id} username={this.state.userprofile.username} email={this.state.userprofile.email}/>       

          </div>

        </Drawer>


        <Drawer
          title="Password Change Form"
          width={520}
          placement="right"
          closable={false}
          onClose={this.onresetdrawerClose}
          visible={this.state.resetmodalvisible}
        >
            <WrappedPasswordResetForm />

        </Drawer>
     

        <Modal              
          visible={this.state.showtimeoutmodal}
          title={<h3>You Have Been Idle!</h3>}
          width={600}
          onCancel={()=>{
            this.setState({showtimeoutmodal:false})
          }}
      
          footer={[
            <Button key="back" type='default' onClick={()=>{
              this.props.logout()
            }}>
              Logout
            </Button>,

            <Button type='primary' key="back" onClick={()=>{this.setState({showtimeoutmodal:false})}}>
            Stay
            </Button>

            ]}
            >
              
              <h5>You Will Get Timed Out. You want to stay?</h5>
                   
      </Modal>

      </div>
  );

  }

}


const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(
      actions.logout(),
      )
  }
}


export default withRouter(connect(null,mapDispatchToProps)(SaccoLayout)) ;

  
